<template>
  <div
    class="project-toggle project-toggle-active project-toggle-active--single"
    :style="{
      backgroundColor: getSelected.color,
      color: getContrast(getSelected.color),
    }"
    @click="$emit('selected', null)"
    v-if="justSelecting && getSelected"
  >
    <span class="mck">M</span>
    <span class="mck" v-if="getSelected.isExternal">r</span>
    <span>
      <strong>ПРОЕКТ:</strong>
      {{ getSelected.projectName }}
    </span>
  </div>
  <ul class="companies-ul-wrapper" v-else>
    <li
      v-for="(c, i) in companies"
      :key="c._id"
      :class="{
        'company-li-inactive': !showActiveProjects,
        'company-li-active': $route.params.companyId === c._id,
        'company-li--less-padding': justSelecting,
      }"
      class="company-li"
      :ref="c._id"
    >
      <div
        class="company-toggle"
        :class="{ 'company-toggle-inactive': !showActiveProjects }"
        @click="toggleElements(c._id, 'company', 'project')"
      >
        <span class="mck">M</span>
        <span>
          <strong>{{ c.companyName }}</strong>
        </span>
        <span
          class="edit"
          @click.stop="toggleEdit(i, 'company')"
          v-if="!justSelecting"
          >c</span
        >
      </div>
      <!-- ПРОЕКТИ -->
      <ul
        class="projects-ul-wrapper"
        :class="{ 'projects-ul-wrapper--less-padding': justSelecting }"
      >
        <li
          v-for="p in c.projects"
          :key="p._id"
          class="project-li"
          :ref="p._id"
        >
          <div
            class="project-toggle"
            :class="{
              'project-toggle-active': $route.params.companyId === c._id,
            }"
            @click="getProject(c, p)"
            :style="{
              backgroundColor: p.color,
              color: getContrast(p.color),
            }"
          >
            <span class="mck">M</span>
            <span class="mck" v-if="p.isExternal">r</span>
            <span>
              <strong>ПРОЕКТ:</strong>
              {{ p.projectName }}
            </span>
          </div>
        </li>
        <li
          class="project-toggle new-btn-mini-toggle"
          :class="{
            'project-toggle-active': $route.params.companyId === c._id,
          }"
          v-if="!justSelecting"
        >
          <a class="new-btn-mini" @click="newProject(c._id)">
            <span class="mck">L</span>
            Създай нов проект
          </a>
        </li>
      </ul>
    </li>
    <transition name="fade">
      <EditInputModal
        v-if="isEditInputModalOpened"
        :inputForEdit="inputForEdit"
        :isComingFromCompany="true"
        @save="handleEdit"
        @close="closeEditInputModal"
      />
    </transition>
  </ul>
</template>

<script>
import contrast from "../mixins/contrast";
import EditInputModal from "./EditInputModal";
export default {
  mixins: [contrast],
  components: {
    EditInputModal,
  },
  props: ["showActiveProjects", "justSelecting", "previewSelected"],
  watch: {
    "$route.name"(to) {
      if (to === "companies") {
        this.getCompanies();
      }
    },
    showActiveProjects() {
      this.getCompanies();
    },
  },
  computed: {
    getSelected() {
      if (!this.previewSelected) return;
      const company = this.companies.find(
        (c) => c._id === this.previewSelected.company
      );
      if (!company) return;
      const project = company.projects.find(
        (p) => p._id === this.previewSelected.project
      );
      if (!project) return;
      return project;
    },
  },
  data() {
    return {
      companies: [],
      search: "",
      isEditInputModalOpened: false,
      selectedIndex: null,
      inputForEdit: {
        value: "",
        where: "",
      },
    };
  },
  methods: {
    toggleEdit(i, where) {
      this.inputForEdit = {
        value: this.companies[i].companyName,
        where: where,
      };
      this.selectedIndex = i;
      this.isEditInputModalOpened = true;
    },
    handleEdit(edited) {
      if (edited.where === "company") {
        let url = `${process.env.VUE_APP_BASE_URI}/company/rename-company/${
          this.companies[this.selectedIndex]._id
        }`;

        this.$http
          .put(url, { companyName: edited.value })
          .then(() => {
            this.$snotify.success(
              "Успешно редактирахте името на отдела. *За старите отчети ще бъде запазено досегашното име."
            );
            this.companies[this.selectedIndex].companyName = edited.value;
            this.closeEditInputModal();
          })
          .catch((error) => {
            console.log(error);
            this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
          });
      }
    },
    closeEditInputModal() {
      this.isEditInputModalOpened = false;
      this.inputForEdit = {
        value: "",
        where: "",
      };
      this.selectedIndex = null;
    },
    getCompanies() {
      this.$store.dispatch("startLoading");
      this.companies = [];
      let type = this.showActiveProjects ? "active" : "inactive";
      let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/${type}`;
      if (this.search.length) {
        requestUrl += `/${this.search}`;
      }
      this.$http.get(requestUrl).then((response) => {
        this.companies = response.data;
        this.$store.dispatch("stopLoading");
      });
    },
    // Filter Companies by companyName
    searchFilter() {
      return this.companies.filter((c) => {
        return c.companyName.includes(this.search);
      });
    },
    toggleElements(id, parent, child) {
      const parentElement = this.$refs[id][0];
      const selectedChildren = parentElement.getElementsByClassName(
        `${child}-toggle`
      );
      if (selectedChildren) {
        // Close
        if (parentElement.classList.contains(`${parent}-li-active`)) {
          for (let i = 0; i < selectedChildren.length; i++) {
            selectedChildren[i].classList.remove(`${child}-toggle-active`);
          }
          parentElement.classList.remove(`${parent}-li-active`);
          // Close children also
          this.closeEverythingInside(id, parent);
        } else {
          // Open
          for (let i = 0; i < selectedChildren.length; i++) {
            selectedChildren[i].classList.add(`${child}-toggle-active`);
          }
          parentElement.classList.add(`${parent}-li-active`);
        }
      }
    },
    closeEverythingInside(id, parent) {
      const element = this.$refs[id][0];
      const types = ["project"];
      for (let i = types.length; i > types.indexOf(parent); i--) {
        const activeToggleItems = element.getElementsByClassName(
          `${types[i]}-toggle-active`
        );
        const activeLiItems = element.getElementsByClassName(
          `${types[i]}-li-active`
        );
        while (activeLiItems.length > 0) {
          activeLiItems[0].classList.remove(`${types[i]}-li-active`);
        }
        while (activeToggleItems.length > 0) {
          activeToggleItems[0].classList.remove(`${types[i]}-toggle-active`);
        }
      }
    },
    // METHODS FOR ROUTING
    newCompany() {
      this.$router.push("/companies/new");
    },
    newProject(companyId) {
      this.$router.push(`/companies/${companyId}`);
    },
    getProject(company, project) {
      if (this.justSelecting) {
        this.$emit("selected", {
          company: company._id,
          companyName: company.companyName,
          project: project._id,
          projectName: project.projectName,
        });
      } else {
        this.$router.push(`/companies/${company._id}/${project._id}`);
      }
    },
  },
  mounted() {
    this.getCompanies();
    // Handle search input
    this.$root.$on("sendSearchInput", (data) => {
      this.search = data;
      this.getCompanies();
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (
      this.$route.name === "newProject" ||
      this.$route.name === "getProject"
    ) {
      this.$refs.companyRef.checkForChanges(next);
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.$route.name === "newProject" ||
      this.$route.name === "getProject"
    ) {
      this.$refs.companyRef.checkForChanges(next);
    } else {
      next();
    }
  },
  destroyed() {
    this.$root.$off("sendSearchInput");
  },
};
</script>

<style scoped>
/* COMPANY */
.company-li {
  background-color: #fff;
  border-left: 4px solid transparent;
  border-radius: 4px;
  display: block;
  overflow: hidden;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.company-li:not(:first-child) {
  margin-top: 10px;
}
.company-li-inactive {
  background-color: #fff8f8;
}
.company-li-active {
  border-left: 4px solid #aeaeae;
  padding-bottom: 15px;
}
.company-li-active.company-li--less-padding {
  padding-bottom: 6px;
}
.company-toggle {
  align-items: center;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  height: 35px;
  padding: 0 10px 0 5px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
  position: relative;
}
.company-toggle-inactive {
  background-color: #fff8f8;
}
.company-toggle:hover {
  color: rgba(0, 0, 0, 0.8);
}
.company-toggle > .mck {
  margin: 0 7px 0 4px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.company-toggle .edit {
  cursor: pointer;
  font-family: "mck";
  font-size: 13px;
  position: absolute;
  right: 10px;
  top: 11px;
  transition: all 0.3s;
}
.company-toggle .edit:hover {
  opacity: 0.5;
}
/* PROJECTS */
.projects-ul-wrapper {
  /* padding-left: 34px; */
  padding-right: 28px;
}
.projects-ul-wrapper--less-padding {
  padding-right: 6px;
}
.project-toggle,
.new-btn-mini-toggle {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 0;
  overflow: hidden;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.project-toggle:hover {
  /* color: rgba(0, 0, 0, 0.8); */
  opacity: 0.8;
}
.project-toggle-active,
.new-btn-mini-toggle-active {
  height: 25px;
}
.project-toggle-active {
  border-radius: 0 4px 4px 0;
  margin: 2px 0;
  padding: 0 15px;
}
.project-toggle-active--single {
  border-radius: 0;
  margin: 0;
}
.new-btn-mini-toggle {
  padding-left: 30px;
}
.project-toggle > .mck {
  margin-right: 7px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.company-li-active .company-toggle .mck,
.project-li-active .project-toggle .mck {
  transform: rotate(90deg);
}
/* FIX TEXTS OVERFLOW */
.company-li span:nth-child(2),
.project-li span:nth-child(2) {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* NEW MINI BTN */
.new-btn-mini-toggle > .mck {
  color: #000;
}
.new-btn-mini {
  align-items: center;
  background-color: #000;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  display: inline-flex;
  padding: 3px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
.new-btn-mini > .mck {
  margin-right: 7px;
  font-size: 10px;
}
.new-btn-mini:hover {
  background-color: rgb(20, 20, 20);
}
</style>
